import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconEmail1"><Path d="M21.5 4.5H22V4H21.5V4.5ZM21.5 19.5V20H22V19.5H21.5ZM2.5 4.5V4H2V4.5H2.5ZM2.5 19.5H2V20H2.5V19.5ZM21.5 4.5H21V19.5H21.5H22V4.5H21.5ZM2.5 4.5V5H21.5V4.5V4H2.5V4.5ZM2.5 19.5H3V4.5H2.5H2V19.5H2.5ZM21.5 19.5V19H2.5V19.5V20H21.5V19.5Z" fill="currentColor"/><Path d="M21.294 5.39545L11.9995 13L2.70508 5.39545" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconEmail1;
